import { LoadingContent } from "@/components/LoadingContent";
import { Button, Container, Stack, Text, Title } from "@mantine/core";
import { useRouter } from "@tanstack/react-router";

export function AccessPending() {
  return <Container py="xl"><Stack><Text>Checking account access…</Text><LoadingContent label="Checking account access…" variant="cards" /></Stack></Container>;
}

export function AccessError({ error }: { error: unknown }) {
  const router = useRouter();
  return <Container py="xl"><Stack><Title order={1}>Could not check account access</Title><Text>{error instanceof Error ? error.message : "Please retry the account access check."}</Text><Button onClick={() => void router.invalidate()}>Retry access check</Button></Stack></Container>;
}
